// extracted by mini-css-extract-plugin
export default {"possibleVolunteers":"PossibleVolunteersCell_possibleVolunteers__-ZlRS"};